module.exports = __webpack_public_path__ + "img/vpn-2.1aef1c9a.webp";